var idCounter = 0;

export class Schema {
  constructor() {
    this.id = idCounter++;
    this.field_label = "";
    this.type = "String";
    this.prefix_label = "";
    this.form_type = "text";
    this.options = [];
    this.default = "";
    this.placeholder = "";
    this.regex = "";
    this.regex_error_message_ja = "";
    this.regex_error_message_en = "";
    this.required = false;
    this.required_reason = "";
    this.number_range = {
      min: null,
      max: null,
    };
    this.date_set_value = {
      default_at: null,
      start_at: null,
      end_at: null,
    };
  }

  setValueFromKey(key, value) {
    switch (key) {
      case "id":
        this.id = value;
        break;
      case "field_label":
        this.field_label = value;
        break;
      case "type":
        this.type = value;
        break;
      case "prefix_label":
        this.prefix_label = value;
        break;
      case "form_type":
        this.form_type = value;
        break;
      case "options":
        this.options = value;
        break;
      case "default":
        this.default = value;
        break;
      case "placeholder":
        this.placeholder = value;
        break;
      case "regex":
        this.regex = value;
        break;
      case "regex_error_message_ja":
        this.regex_error_message_ja = value;
        break;
      case "regex_error_message_en":
        this.regex_error_message_en = value;
        break;
      case "required":
        this.required = value;
        break;
      case "required_reason":
        this.required_reason = value;
        break;
      case "number_range":
        this.number_range = value;
        break;
      case "date_set_value":
        this.date_set_value = value;
        break;
      default:
        throw new Error(`unexpected key: ${key}`);
    }
  }
}

export const createSchemaFromObject = (object) => {
  const schema = new Schema();
  schema.id = object.id;
  schema.field_label = object.field_label;
  schema.type = object.type;
  schema.prefix_label = object.prefix_label;
  schema.form_type = object.form_type;
  schema.options = object.options;
  schema.default = object.default;
  schema.placeholder = object.placeholder;
  schema.regex = object.regex;
  schema.regex_error_message_ja = object.regex_error_message_ja;
  schema.regex_error_message_en = object.regex_error_message_en;
  schema.required = object.required;
  schema.required_reason = object.required_reason;
  schema.number_range = object.number_range;
  schema.date_set_value = object.date_set_value;
  return schema;
};
